import React, { PureComponent, Suspense } from "react";
import { Layout, Icon, message, Button, Tooltip, Modal } from "antd";
import classNames from "classnames";
import Link from "umi/link";
import { connect } from 'dva';
import styles from "./index.less";
import { cloneDeep } from 'lodash'
import PageLoading from "../PageLoading";
import { getDefaultCollapsedSubMenus } from "./SiderMenuUtils";
import { changePwd, setDefaultRole } from "@/services/user";
import ChangePwd from "./ChangePwd";
import { CLINIC_NAME, APPLICATION_SYS, TOKEN_KEY, ROLE_KEY, ROLE_DATAPERMISSION_KEY, ROLE_CODE, CLINIC_KEY, APP_CODE, DEFAULT_ID, FIRST_ROUTE, CLINIC_LOGO, IS_SIMPLE_PWD } from "@/utils/consts";
import ChangeRoleModal from "../ChangeRoleModal";
import router from 'umi/router';
import { arrayToTree } from "@/utils/utils";
import { trackEvent } from "@/utils/tracker";
const { confirm } = Modal;
const BaseMenu = React.lazy(() => import("./BaseMenu"));
const { Sider } = Layout;

const appList = [{
  key: 'customer',
  name: '客户',
  icon: 'user'
}, {
  key: 'order',
  name: '订单',
  icon: 'snippets'
}, {
  key: 'setting',
  name: '设置',
  icon: 'setting'
}]

@connect(({ user }) => ({
  currentUser: user.currentUser,
}))
class SiderMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      openKeys: getDefaultCollapsedSubMenus(props),
      changePwdVisible: false,
      currentApp: 'customer',
      appWrapVisible: false,
      changeRoleVisible: false,
      currentRoleId: Number(window.localStorage.getItem(ROLE_KEY)),
      currentRoleCode: window.localStorage.getItem(ROLE_CODE),
      currentClinic: window.localStorage.getItem(CLINIC_KEY),
      counter: 0
    };
  }

  componentDidMount() {
    let that = this;
    //如果是弱密码则提示修改
    if (window.localStorage.getItem(IS_SIMPLE_PWD) && JSON.parse(window.localStorage.getItem(IS_SIMPLE_PWD))) {
      confirm({
        title: '密码安全提示',
        content: '您的登录密码比较简单，请设置长度超过6位的英文和数字的组合',
        okText: '去修改',
        cancelText: '下次再说',
        iconType: 'warning',
        onOk() {
          window.localStorage.removeItem(IS_SIMPLE_PWD)
          that.setState({
            changePwdVisible: true
          })
        },
        onCancel() {
          window.localStorage.removeItem(IS_SIMPLE_PWD)
        },
      });
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { pathname } = state;
    if (props.location.pathname !== pathname) {
      return {
        pathname: props.location.pathname,
        openKeys: getDefaultCollapsedSubMenus(props),
      };
    }
    return null;
  }

  isMainMenu = key => {
    const { menuData } = this.props;
    return menuData.some(item => {
      if (key) {
        return item.key === key || item.path === key;
      }
      return false;
    });
  };

  handleOpenChange = openKeys => {
    const moreThanOne = openKeys.filter(openKey => this.isMainMenu(openKey)).length > 1;
    this.setState({
      openKeys: moreThanOne ? [openKeys.pop()] : [...openKeys],
    });
  };

  handleLogout = () => {
    window.localStorage.removeItem(TOKEN_KEY)
    window.localStorage.removeItem('user-authority')
    window.localStorage.clear();
    window.location.href = '/user/login'
  }

  handleChangePwd = () => {
    this.setState({ changePwdVisible: true })
  }

  handleChangeRole() {
    this.setState({
      changeRoleVisible: true
    })
  }

  handleChangeApp(key) {
    this.setState({ currentApp: key, appWrapVisible: false })
  }

  renderAppsList() {
    const { currentApp } = this.state
    return (
      <div className={styles.appsWrap}>
        {
          appList.map(_ => <Button
            key={_.key}
            onClick={this.handleChangeApp.bind(this, _.key)}
            type={currentApp === _.key ? 'primary' : 'default'}
          >
            <Icon type={_.icon} /> {_.name}
          </Button>
          )
        }
      </div>
    )
  }

  modalProps = () => {
    const that = this

    return {
      title: '修改密码',
      visible: this.state.changePwdVisible,
      maskClosable: false,
      // confirmLoading: loading.effects[`rolePermission/${modalType}`],
      wrapClassName: 'vertical-center-modal',
      onOk(data) {
        that.setState({ changePwdLoading: true })
        changePwd({ oldPassword: data.oldPhrase, password: data.newPhrase }).then((res) => {
          if (res.code === 0) {
            message.success('密码修改成功')
            that.setState({ changePwdVisible: false })
          }
        })
      },
      onCancel() {
        that.setState({ changePwdVisible: false })
      },
    }
  }


  get roleModalProps() {
    const { changeRoleVisible, currentRoleId, currentRoleCode, currentClinic } = this.state
    const { currentUser } = this.props
    let currentUserTemp = cloneDeep(currentUser);
    let temp = currentUserTemp.rolePermissionVos || [];
    //集团角色
    currentUserTemp && currentUserTemp.organizationResps.forEach((item) => {
      if (item.name === '安肯集团') {
        let orgTemp = { ...item };
        orgTemp.userClinicRoles = item.userOrganizationRoles;
        orgTemp.shortName = '安肯集团';
        orgTemp.id = '0';
        currentUserTemp && currentUserTemp.clinicResps && currentUserTemp.clinicResps.push(orgTemp);
      }
    })
    currentUserTemp && currentUserTemp.clinicResps.forEach((item, i) => {
      item.userClinicRoles.forEach((ele, index) => {
        temp.forEach((element) => {
          let temp = { ...element };

          if (ele.roleId === temp.roleId) {
            temp.clinicId = ele.clinicId;
            currentUserTemp.clinicResps[i].userClinicRoles[index] = temp
          }
        })
      })
    })
    return {
      width: 800,
      visible: changeRoleVisible,
      title: '切换身份',
      maskClosable: false,
      wrapClassName: 'vertical-center-modal',
      clinics: currentUserTemp.clinicResps,
      roles: currentUserTemp.rolePermissionVos.filter(_ => _.code !== 'ROLE_ADMIN'),
      current: currentRoleId,
      currentCode: currentRoleCode,
      currentClinicProp: currentClinic,
      onOk: (roleId, code, currentDataPermission, currentClinicId, currentApplicationId, currentUrlPermissions, currentClinicName, currentClinicLogo, currentRecord) => {

        let boolTemp = false;
        if (currentClinicId !== currentClinic) {
          boolTemp = true;
        } else {
          if (roleId !== currentRoleId) {
            boolTemp = true;
          }
        }
        if (boolTemp) {
          trackEvent({ functionPage: `云平台-切换角色-${currentClinicName}-${currentRecord.displayName}`, operateDetail: '切换身份' })

          const role = currentUserTemp.rolePermissionVos.filter(_ => _.roleId === roleId)[0]
          const route = (role.permissions || []).some(_ => _.type === 'LINK') ?
            ((role.permissions || []).filter(_ => _.type === 'LINK' && _.applicationId === currentApplicationId)[0] && (role.permissions || []).filter(_ => _.type === 'LINK' && _.applicationId === currentApplicationId)[0].value)
            :
            undefined
          if (!route) {
            message.info('此账号没有此系统菜单权限！')
            return
          }
          window.localStorage.setItem(ROLE_KEY, roleId)
          window.localStorage.setItem(ROLE_CODE, code)
          window.localStorage.setItem(CLINIC_KEY, currentApplicationId === APPLICATION_SYS['安肯集团'] ? '' : currentClinicId)
          window.localStorage.setItem(CLINIC_LOGO, currentClinicLogo)
          window.localStorage.setItem(CLINIC_NAME, currentClinicName)
          window.localStorage.setItem(APP_CODE, currentApplicationId)
          window.localStorage.setItem(ROLE_DATAPERMISSION_KEY, currentDataPermission || 'PERSONAL')

          window.localStorage.setItem(FIRST_ROUTE, route);
          router.push(route)
          location.reload()
        }
        this.setState({ changeRoleVisible: false, currentRoleId: roleId, currentClinic: currentClinicId })
      },
      onCancel: () => {
        this.setState({ changeRoleVisible: false })
      },
    }
  }

  handleSetDefaultRole() {
    const that = this
    if (`${localStorage.getItem(ROLE_KEY)}${localStorage.getItem(CLINIC_KEY)}` === localStorage.getItem(DEFAULT_ID)) return;
    Modal.confirm({
      title: '是否将该角色设为默认登录角色?',
      content: '',
      onOk() {
        setDefaultRole({ applicationId: window.localStorage.getItem(APP_CODE), roleId: window.localStorage.getItem(ROLE_KEY), clinicId: window.localStorage.getItem(CLINIC_KEY) }).then((res) => {
          if (res.code === 0) {
            message.success('设置默认角色成功')
            localStorage.setItem(DEFAULT_ID, `${window.localStorage.getItem(ROLE_KEY)}${window.localStorage.getItem(CLINIC_KEY)}`)
            that.setState({ counter: that.state.counter + 1 })
          }
        })
      },
      onCancel() {
        console.log('Cancel')
      },
      okText: '是',
      cancelText: '否'
    });
  }

  render() {
    const { logo, collapsed, onCollapse, fixSiderbar, theme } = this.props;
    const { openKeys, changePwdVisible, currentApp, changeRoleVisible, currentRoleId } = this.state;
    const defaultProps = collapsed ? {} : { openKeys };
    const siderClassName = classNames(styles.sider, {
      [styles.fixSiderbar]: fixSiderbar,
      [styles.light]: theme === "light",
    });
    const type = collapsed ? "right" : "left";

    const { currentUser } = this.props
    const app = appList.filter(_ => _.key === currentApp)[0]

    const currentRole = (currentUser.rolePermissionVos || []).filter(_ => _.roleId === Number(currentRoleId))[0] || {}
    const menus = (currentRole.permissions || []).filter(_ => ['MENU', 'LINK'].indexOf(_.type) > -1 && _.value.indexOf(':id') < 0).map(_ => {
      return {
        icon: _.icon,
        name: _.name,
        text: _.name,
        path: _.value,
        id: _.id,
        pid: _.parentId
      }
    })

    // const menus = (currentRole.permissions || []).filter(_ => _.type === 'MENU' || _.type === 'LINK').map(_ => {
    //     return {
    //       icon: _.icon,
    //       name: _.name,
    //       text: _.name,
    //       path: _.value,
    //       id: _.id,
    //       pid: _.parentId
    //     }
    //   })

    const menuTree = arrayToTree(menus)

    return (
      <Sider
        trigger={null}
        collapsible
        collapsedWidth={60}
        collapsed={collapsed}
        breakpoint="lg"
        // onCollapse={onCollapse}
        width={196}
        theme={theme}
        className={siderClassName}
      >
        <div className={styles.logo} id="logo">

          <Link to={`${window.localStorage.getItem(FIRST_ROUTE) || '/'}`}>
            <img src={window.localStorage.getItem(CLINIC_LOGO) && window.localStorage.getItem(CLINIC_LOGO) !== 'null' && window.localStorage.getItem(CLINIC_LOGO) !== 'undefined' ? window.localStorage.getItem(CLINIC_LOGO) : logo} alt="logo" />
            <h1 style={{ display: !collapsed ? 'block' : 'none', width: 130 }}>{window.localStorage.getItem(CLINIC_NAME) || '安肯云门店'}</h1>
          </Link>
        </div>
        {!collapsed &&
          <div className={styles.userTop}>
            <div className={styles.userInfo}>
              <div className="avatar-wrap">
                <Icon type="user" style={{ fontSize: 20 }} />
              </div>
              <div className="right-info">
                <p>{currentUser.nickname}</p>
                <p className={styles.roleRow}>
                  <span>{currentRole.name}</span>
                  <Tooltip title={`${localStorage.getItem(ROLE_KEY)}${localStorage.getItem(CLINIC_KEY)}` === localStorage.getItem(DEFAULT_ID) ? '当前为默认角色' : '设为默认角色'}><a onClick={this.handleSetDefaultRole.bind(this)}><Icon type={`${localStorage.getItem(ROLE_KEY)}${localStorage.getItem(CLINIC_KEY)}` === localStorage.getItem(DEFAULT_ID) ? 'user' : "user-add"} /></a></Tooltip>
                  <Tooltip title="切换身份"><a onClick={this.handleChangeRole.bind(this)}><Icon type="swap" /></a></Tooltip>
                </p>
                <a style={{ marginRight: 8 }} onClick={this.handleChangePwd}>更改密码</a>
                <a onClick={this.handleLogout}>退出登录</a>
              </div>
            </div>
            {/* <div style={{ textAlign: 'center' }}>
            <Popover
              // visible={appWrapVisible}
              // title="切换应用"
              arrowPointAtCenter={true}
              content={
                this.renderAppsList()
              }
              placement="right"
            >
              <Button
                type="primary"
                onMouseOver={() => this.setState({ appWrapVisible: true})}
                onMouseOut={() => this.setState({ appWrapVisible: false})}
              >
                <Icon type={app.icon} />
                {app.name}
                <Divider type="vertical" style={{ marginLeft: 35, marginRight: 15 }} />
                <Icon type="right" style={{ fontSize: 12 }} />
              </Button>
            </Popover>
          </div> */}
          </div>}
        <Suspense fallback={<PageLoading />}>
          <BaseMenu
            {...this.props}
            menuData={menuTree}
            mode="inline"
            handleOpenChange={this.handleOpenChange}
            onOpenChange={this.handleOpenChange}
            style={{ padding: "16px 0", width: "100%" }}
            {...defaultProps}
          />
        </Suspense>
        <div className={styles["menu-toggle"]} onClick={() => onCollapse(!collapsed)}>
          <Icon type={type} style={{ color: "#fff", pointerEvents: "none" }} />
        </div>
        {changePwdVisible && <ChangePwd {...this.modalProps()} />}
        {changeRoleVisible && <ChangeRoleModal {...this.roleModalProps} />}
      </Sider>
    );
  }
}

export default SiderMenu
